import { render, staticRenderFns } from "./MedicalFiles.vue?vue&type=template&id=90c16ab0"
import script from "./MedicalFiles.vue?vue&type=script&lang=js"
export * from "./MedicalFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports